import { isEditorLive } from '@heidi/editor/core';
import { type Editor } from '@tiptap/react';
import { isSafari } from 'react-device-detect';

/**
 * Fix Safari ghost cursor issue by performing a blur/focus cycle to reset cursor state.
 * This should be called after programmatically inserting content into the editor.
 * Only applies the fix if the user is on Safari.
 *
 * @param editor - The Tiptap editor instance
 */
export const fixCursorIfSafari = (editor: Editor) => {
  if (!isSafari) {
    return;
  }

  queueMicrotask(() => {
    if (!isEditorLive(editor, 'fixSafariCursor.microtask')) {
      return;
    }
    const newPos = editor.state.selection.to;
    editor.commands.blur();
    requestAnimationFrame(() => {
      if (!isEditorLive(editor, 'fixSafariCursor.raf')) {
        return;
      }
      editor.chain().focus().setTextSelection(newPos).run();
    });
  });
};
